import { IconStorage } from "@app/shared/icons/interfaces";

export const helpCustom: IconStorage = {
  svgCode: () => ([
    "M7 6.40732C7.39964 5.27125 8.18846 4.31328 9.22673 3.70307C10.265 3.09287 11.4857 2.86982 12.6727 3.07341C13.8597 3.27701 14.9363 3.89412 15.7119 4.81545C16.4875 5.73678 16.9119 6.90286 16.9102 8.10717C16.9102 11.5069 11.8106 13.2067 11.8106 13.2067M11.9466 20.0062H11.9636",
  ]),
};
